<div class="language-settings">
  <h2>Langue</h2>
  
  <div class="language-selector">
    <label>Sélectionner la langue</label>
    <mat-form-field appearance="fill">
      <mat-select [(value)]="currentLanguage" (selectionChange)="onLanguageChange($event.value)">
        <mat-option value="fr">Français</mat-option>
        <mat-option value="en">English</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<script>
document.getElementById('languageForm').addEventListener('submit', function(e) {
  e.preventDefault();
  const interfaceLanguage = document.getElementById('interfaceLanguage').value;

  // Simulate saving the settings
  setTimeout(() => {
    alert(`Paramètres de langue enregistrés :\nLangue de l'interface : ${interfaceLanguage === 'fr' ? 'Français' : 'Anglais'}`);
  }, 500);
});

// Add some interactivity
const select = document.querySelector('select');
select.addEventListener('focus', () => {
  select.style.transform = 'scale(1.02)';
});
select.addEventListener('blur', () => {
  select.style.transform = 'scale(1)';
});

// Animate the language icon
const languageIcon = document.querySelector('.language-icon');
languageIcon.addEventListener('mouseover', () => {
  languageIcon.style.transform = 'rotate(180deg)';
  languageIcon.style.transition = 'transform 0.5s ease';
});
languageIcon.addEventListener('mouseout', () => {
  languageIcon.style.transform = 'rotate(0deg)';
});

// Add a ripple effect to the button
const button = document.querySelector('button');
button.addEventListener('click', function(e) {
  let ripple = document.createElement('span');
  ripple.classList.add('ripple');
  this.appendChild(ripple);
  let x = e.clientX - e.target.offsetLeft;
  let y = e.clientY - e.target.offsetTop;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  setTimeout(() => {
    ripple.remove();
  }, 300);
});

// Add ripple effect styles
const style = document.createElement('style');
style.textContent = `
  button {
    position: relative;
    overflow: hidden;
  }
  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 0.6s linear;
    background-color: rgba(255, 255, 255, 0.7);
  }
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

// Change language icon based on selection
select.addEventListener('change', (e) => {
  const selectedLanguage = e.target.value;
  const languageIcon = document.querySelector('.language-icon');
  
  if (selectedLanguage === 'fr') {
    languageIcon.style.stroke = '#3498db';
  } else {
    languageIcon.style.stroke = '#e74c3c';
  }
});
</script>